/**
 * WC26 tournament stage bands for the standings-over-time chart.
 *
 * Hardcoded matchday ranges align with the fixture schedule: group rounds 1–3 (MD1–17),
 * Round of 32 (MD18–23), Round of 16 (MD24–27), Finals (MD28–34).
 */
import type { ChartScales } from './bumpChartGeometry';

export type ChartStageBandId = 'G1' | 'G2' | 'G3' | 'R32' | 'R16' | 'Finals';

export interface ChartStageBandDef {
  id: ChartStageBandId;
  label: string;
  mdStart: number;
  mdEnd: number;
}

export const CHART_STAGE_BANDS: ChartStageBandDef[] = [
  { id: 'G1', label: 'G1', mdStart: 1, mdEnd: 7 },
  { id: 'G2', label: 'G2', mdStart: 8, mdEnd: 13 },
  { id: 'G3', label: 'G3', mdStart: 14, mdEnd: 17 },
  { id: 'R32', label: 'R32', mdStart: 18, mdEnd: 23 },
  { id: 'R16', label: 'R16', mdStart: 24, mdEnd: 27 },
  { id: 'Finals', label: 'Finals', mdStart: 28, mdEnd: 34 },
];

export interface ResolvedChartStageBand extends ChartStageBandDef {
  effectiveEnd: number;
}

/** Bands visible for the chart's current maxMatchday; in-progress band is clipped. */
export function resolveChartStageBands(maxMatchday: number): ResolvedChartStageBand[] {
  if (maxMatchday < 1) return [];

  return CHART_STAGE_BANDS.flatMap((band) => {
    if (band.mdStart > maxMatchday) return [];
    return [{ ...band, effectiveEnd: Math.min(band.mdEnd, maxMatchday) }];
  });
}

/** Pixel x-range for a stage band, using half-matchday edges so bands tile without gaps. */
export function chartStageBandXBounds(
  scales: ChartScales,
  mdStart: number,
  mdEnd: number,
): { x1: number; x2: number } {
  return {
    x1: scales.xScale(mdStart - 0.5),
    x2: scales.xScale(mdEnd + 0.5),
  };
}
